export default {"src":"/_next/static/image/public/images/ic_standard_shipment.647340f604c08edcba4a9a63364a7fab.gif","height":225,"width":225};